var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpportunitiesi = function SvgOpportunitiesi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21 14.057a1 1 0 0 0-.02-.1c-.006-.051 0-.1-.015-.152l-1.871-9.357A1.81 1.81 0 0 0 17.327 3H6.673a1.81 1.81 0 0 0-1.767 1.448L3.036 13.8c-.011.05-.01.1-.016.154a1 1 0 0 0-.02.1c0 .012.006.022.007.034S3 14.136 3 14.159V19.2A1.8 1.8 0 0 0 4.8 21h14.4a1.8 1.8 0 0 0 1.8-1.8v-5.041c0-.023-.006-.045-.007-.068s.007-.022.007-.034M6.419 4.751a.26.26 0 0 1 .254-.208h10.654a.26.26 0 0 1 .254.208l1.7 8.535h-4.2a.77.77 0 0 0-.772.771 2.314 2.314 0 0 1-4.628 0 .77.77 0 0 0-.772-.771h-4.2zM19.2 19.457H4.8a.26.26 0 0 1-.259-.259v-4.369H8.22a3.858 3.858 0 0 0 7.56 0h3.677V19.2a.26.26 0 0 1-.257.257"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpportunitiesi);
export default ForwardRef;